import { cn } from '@commenda/utils';
import React from 'react';

import { Icons } from '../../Icons';
import { DataGridIntent, DataGridTrend } from '../types';

export interface DataGridCellValueTrendProps {
  value: React.ReactNode;
  trend?: DataGridTrend;
  intent?: DataGridIntent;
  className?: string;
}

const DATA_GRID_TREND_VALUE_CLASS_NAMES: Record<DataGridIntent, string> = {
  positive: 'text-text-success',
  critical: 'text-text-error',
  neutral: 'text-text-primary',
};

const DATA_GRID_TREND_DISC_CLASS_NAMES: Record<DataGridIntent, string> = {
  positive: 'bg-utility-success-500',
  critical: 'bg-utility-error-500',
  neutral: 'bg-utility-gray-500',
};

const DataGridCellValueTrend = ({
  value,
  trend = 'none',
  intent = 'neutral',
  className,
}: DataGridCellValueTrendProps) => (
  <div className={cn('flex w-full items-center justify-between', className)}>
    {trend === 'none' ? null : (
      <span
        aria-hidden
        className={cn(
          'flex size-4 shrink-0 items-center justify-center rounded-full',
          DATA_GRID_TREND_DISC_CLASS_NAMES[intent]
        )}
      >
        {trend === 'up' ? (
          <Icons.ArrowUp className="size-3 text-fg-white" />
        ) : (
          <Icons.ArrowDown className="size-3 text-fg-white" />
        )}
      </span>
    )}
    <span
      className={cn(
        'txt-small-regular min-w-0 flex-1 truncate text-right',
        DATA_GRID_TREND_VALUE_CLASS_NAMES[intent]
      )}
    >
      {value}
    </span>
  </div>
);

export { DataGridCellValueTrend };
